<script setup lang="ts">
import { computed } from 'vue';
import type { EmailParticipant } from '@apparatix/schemas/DashboardEmails';
import { useDashboardEmails, useUtilities } from '@apparatix/composables';
import { Typography } from '@apparatix/library/core';
import NameAndEmail from '../orphaned-emails/NameAndEmail.vue';

type Props = {
  participants: EmailParticipant[],
};

const props = defineProps<Props>();

const { getParticipantDisplay } = useDashboardEmails();
const { arrayHasValues } = useUtilities();

const primary = computed(() => props.participants[0]);

const tooltipValue = computed(() => props.participants?.slice(1)?.map(participant => `${getParticipantDisplay(participant)}\n\n`));
</script>
<template>
  <div class="flex gap-1 items-center">
    <NameAndEmail :name="primary.name" :email="primary.email" />
    <Typography
      v-if="arrayHasValues(props.participants, { min: 2 })"
      v-tooltip="tooltipValue"
      variant="small-body"
      muted
    >
      +{{ props.participants.length - 1 }} more
    </Typography>
  </div>
</template>
